import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.66669 16C1.66669 8.08391 8.08394 1.66666 16 1.66666C23.9162 1.66666 30.3334 8.08391 30.3334 16C30.3334 23.9161 23.9162 30.3333 16 30.3333C8.08394 30.3333 1.66669 23.9161 1.66669 16ZM12.7071 11.2929C12.3166 10.9024 11.6834 10.9024 11.2929 11.2929C10.9024 11.6834 10.9024 12.3166 11.2929 12.7071L14.5858 16L11.2929 19.2929C10.9024 19.6835 10.9024 20.3165 11.2929 20.7071C11.6834 21.0976 12.3166 21.0976 12.7071 20.7071L16 17.4143L19.293 20.7071C19.6835 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3165 21.0976 19.6835 20.7071 19.2929L17.4143 16L20.7071 12.7071C21.0976 12.3166 21.0976 11.6834 20.7071 11.2929C20.3166 10.9024 19.6835 10.9024 19.293 11.2929L16 14.5857L12.7071 11.2929Z",
		fill: "currentColor"
	})
});
export default SvgError;
